export default "__VITE_ASSET__DJ8cvhpq__"